import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.EditCounterpartyPaymentDetailsPopupContent', {
    titleEdit: 'Edit {contact} payment details',
    titleNew: 'Add {contact} payment details',
    save: 'Save',
    helpText: 'What are contact payment details?',
    learnMore: 'Learn more',
    inputPlaceholder: 'Enter...',
    selectPlaceholder: 'Select...',
    defaultCheckbox: 'Set as default',
    payeeBankCountry: 'Bank account country',
    payerBankCountry: 'Contact country',
    accountCurrency: 'Account currency',
});
